// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "news-4a753f38/chunk-" + {"190": "144b49102acdf44f","238": "69cfd44fc7d4aae2","288": "8f84af20ad917330",}[chunkId] + ".js"
}